import React from "react";
import styles from "./Input.module.scss";
const CheckBox = ({ text, value, onChange, errors, touched }) => {
  return (
    <div
      style={{
        alignItems: "center",
        display: "flex",
        gap: "10px",
        paddingTop: "5px",
      }}
    >
      <label
        className={styles["checkbox-container"]}
        style={{
          marginTop: "-16px",
        }}
      >
        <input
          type="checkbox"
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span
          className={
            styles[`${errors && touched ? "red-checkmark " : "checkmark"}`]
          }
        ></span>
        <p>{text}</p>
      </label>
    </div>
  );
};

export default CheckBox;
